import { PX } from '@utils/constants';
import { createGlobalStyle, css } from 'styled-components';

const GlobalStyleSheet = createGlobalStyle`
  ${({ isRevamp }) => {
    const fontFamily = !isRevamp
      ? 'Segma, sans-serif'
      : 'TT Commons Pro, sans-serif';
    return css`
      * {
        -webkit-tap-highlight-color: transparent;
        -webkit-overflow-scrolling: touch;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: ${fontFamily} !important;
      }
      body {
        height: ${({ origin }) => (origin === PX ? 'auto' : '100vh')};
        overflow-y: ${({ origin }) => (origin === PX ? 'hidden' : 'initial')};
        background-color: ${({ theme }) =>
          theme.color('shape-color-background-primary')};
        padding: 0;
        margin: 0;
        font-family: ${fontFamily};
        font-size: 12px;
        letter-spacing: 0 !important;
        & #__next {
          height: ${({ origin }) => (origin === PX ? 'auto' : '100vh')};
          display: flex;
          flex-direction: column;
        }
        header {
          z-index: 1000 !important;
        },
      ${({ isDesktop }) =>
        isDesktop &&
        `
        background-color: white;
        overflow-y: auto;
        overflow-x: hidden;
        min-height: 100vh;
        min-width: 1068px !important;
        font-family: ${fontFamily};
      `},
    }`;
  }}
  ${({ isios, theme, isDesktop }) =>
    isios &&
    !isDesktop &&
    `
    // iPhone SE
  @media ${theme.mediaQueries.mobileIos} {
    header{
      padding-top: 0 !important;
    }
  }
  // iPhone 11, XR, iphone 13 mini
  @media ${theme.mediaQueries.mobileIosNotch}
  {
    header{
      padding-top: 65px !important;
    }
  }
  // iPhone 14 pro Max
  @media ${theme.mediaQueries.mobileIosNotch14},
  ${theme.mediaQueries.mobileIosNotchMax},
  ${theme.mediaQueries.mobileIosNotchXMax}
  {
    header{
      padding-top: 70px !important;
    }
  }
   // iPhone 14 pro
    @media only screen
    and (device-width: 393px)
    and (device-height: 852px)
    and (-webkit-device-pixel-ratio: 3) {
          header{
      padding-top: 70px !important;
    }
    }
    //iPhone 12, iPhone 12 pro, iPhone 13, iPhone 13 pro
    @media only screen
    and (device-width: 390px)
    and (device-height: 844px)
    and (-webkit-device-pixel-ratio: 3) {
          header{
      padding-top: 70px !important;
    }
    }
    // iPhone 14 plus, iPhone 13 pro Max, iPhone 12 pro Max
    @media only screen
        and (device-width: 428px)
        and (device-height: 926px)
        and (-webkit-device-pixel-ratio: 3) {
    header{
      padding-top: 70px !important;
    }
    }
`}
`;

export default GlobalStyleSheet;
